import { useEffect, useRef, useState } from 'react'
import { useMediaQuery } from 'react-responsive'

import styles from './IFrame.module.css'

export type IFrameProps = {
  src: any
  frameHeight?: string
  mobileFrameHeight?: string
}

export const PhnxIFrame: React.FC<IFrameProps> = ({
  src,
  frameHeight = '1000px',
  mobileFrameHeight = '1050px',
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const isDesktop = useMediaQuery({ query: '(min-width: 600px)' })
  const [minHeight, setMinHeight] = useState(isDesktop ? frameHeight : mobileFrameHeight)

  useEffect(() => {
    const iframe = iframeRef.current
    if (iframe) {
      const resizeIframe = () => {
        try {
          // Attempt to access the iframe's content body scroll height
          const iframeDoc = iframe.contentWindow?.document
          if (iframeDoc) {
            // Try accessing a property within the iframe's document to ensure it's accessible
            const height = iframeDoc.body?.scrollHeight
            if (height && minHeight !== height + 'px') {
              setMinHeight(height + 'px')
              return
            }
          }
        } catch (error) {
          // Catch any errors, including cross-origin access errors
          console.error('Error accessing iframe content:', error)
        }

        const height = isDesktop ? frameHeight : mobileFrameHeight
        setMinHeight(height)
      }
      const resizeIframeOnWindowResize = () => {
        resizeIframe()
      }

      //timeout to allow iframe to load
      const timeoutId = setTimeout(() => {
        resizeIframe()
      }, 1000)
      iframe.addEventListener('load', resizeIframe)
      window.addEventListener('resize', resizeIframeOnWindowResize)
      return () => {
        clearTimeout(timeoutId)
        iframe.removeEventListener('load', resizeIframe)
        window.removeEventListener('resize', resizeIframeOnWindowResize)
      }
    }
  }, [frameHeight, isDesktop, minHeight, mobileFrameHeight])

  return (
    src && (
      <div
        className={`${styles['iframe-container']} flex-1 flex flex-col`}
        style={{ minHeight: `${minHeight}` }}
      >
        <iframe
          ref={iframeRef}
          src={src}
          className="w-full h-full border-0 overflow-auto flex flex-1"
          title="Url Embed"
        >
          Loading…
        </iframe>
      </div>
    )
  )
}
